// @flow

type Opts = {
  margin?: {
    top?: 'string' | number,
    bottom?: 'string' | number
  },
  noNormalize?: boolean
}

export function getScrollPercentage(el: HTMLElement, opts?: Opts = {}) {
  const { top, bottom, height } = el.getBoundingClientRect()
  const margins = {
    top: opts.margin && opts.margin.top ? toPixelValue(opts.margin.top, height) : 0,
    bottom: opts.margin && opts.margin.bottom ? toPixelValue(opts.margin.bottom, height) : 0
  }

  const bottomWithMargin = bottom - margins.bottom
  const topWithMargin = top + margins.top
  const center = top + height / 2
  const isInViewport = bottomWithMargin > 0 && topWithMargin < window.innerHeight

  const centerPercent = 100 - (center / window.innerHeight) * 100
  const topPercent = (-(topWithMargin - window.innerHeight) / window.innerHeight) * 100
  const bottomPercent = ((window.innerHeight - bottomWithMargin) / window.innerHeight) * 100
  const percent = (-topWithMargin / (height - window.innerHeight)) * 100
  return {
    center: opts.noNormalize ? centerPercent : normalize(centerPercent),
    top: opts.noNormalize ? topPercent : normalize(topPercent),
    bottom: opts.noNormalize ? bottomPercent : normalize(bottomPercent),
    percent: opts.noNormalize ? percent : normalize(percent),
    isInViewport: isInViewport
  }
}

function toPixelValue(val: string | number, elValue?: number) {
  const value: string = String(val)
  let unit = ['vh', 'vw', 'px', '%'].find(u => value.includes(u)) || 'px'
  let finalNumber: number = parseFloat(value.split(unit)[0])
  switch (unit) {
    case 'vh':
      return parseInt((window.innerHeight / 100) * finalNumber)
    case 'vw':
      return parseInt((window.innerWidth / 100) * finalNumber)
    case '%':
      return parseInt((finalNumber * (elValue || window.innerHeight)) / 100)
    case 'px':
    default:
      return parseInt(finalNumber)
  }
}

function normalize(value, max = 100, min = 0) {
  return Math.round(Math.min(max, Math.max(value, min)))
}
